import React from 'react'
import { DataGrid } from '@/components/DataGrid/DataGrid'
import api from '@/shared/api/api'
import { useFetch } from '@/shared/hooks/useFetch'
import { RecordField, TextField } from '@/shared/ui/Fields/Fields'
import { FlexColumn } from '@/shared/ui/Layouts/Flex'
import { BodyExecuteTestCaseRunApiTestRunsExecuteTestCaseRunIdPut, TestCaseRunResponseDTO, TestCaseRunUpdateDTO, TestRunResponseDTO } from '@/shared/api/gen/data-contracts'
import useModals from '@/shared/hooks/useModal'
import LeftSideModal from '@/shared/ui/Modals/LeftSideModal/LeftSideModal'
import TestCaseRunForm from '@/pages/test_runs/form/TestCaseRunForm'
import TestRunDetail from '@/pages/test_runs/TestRunDetail'
import { useNavigate } from 'react-router-dom'

type Props = {}

function TestRunDetailGrid({testRunID}: any) {
    const navigate = useNavigate();
    const {data} = useFetch<TestRunResponseDTO>(()=>api.test_runs.getTestRunDetailApiTestRunsIdGet(testRunID), {} as unknown as TestRunResponseDTO, [testRunID])
    const {data: testCasesRuns} = useFetch<TestCaseRunResponseDTO[]>(
        ()=>api.test_runs.getTestCaseRunsApiTestRunsIdTestCasesGet(testRunID),
        [] as unknown as TestCaseRunResponseDTO[],
        [testRunID]
    )
    const {openModal} = useModals();

    const openTestCaseExecutionForm = (testCaseRunID: number) => {
        const executeTest = (data: BodyExecuteTestCaseRunApiTestRunsExecuteTestCaseRunIdPut) => {api.test_runs.executeTestCaseRunApiTestRunsExecuteTestCaseRunIdPut(Number(testCaseRunID), data)}
        openModal(
            <LeftSideModal>
                <TestCaseRunForm defaultData={{}} testCaseRunID={testCaseRunID}  onSubmit={(data)=>{executeTest(data)}}/>
            </LeftSideModal>
        )
    }
    const openTestCaseExecutionDeatail = (testCaseRunID: number) => {
        openModal(
            <LeftSideModal>
                <TestRunDetail testCaseRunID={testCaseRunID}/>
            </LeftSideModal>
        )
    }

    return (
        <FlexColumn
            style={{
                justifyContent: "flex-start",
                height: "100%",
                width: "100%"
            }}
        >
            <DataGrid
                title={data?.id ? `Тест #${data.id}` : ''}
                records={testCasesRuns}
            >
                <TextField key='id' label="ID" />
                <RecordField
                    label='Тест-кейс'
                    render={(record) => record?.test_case_ref ? (
                        <span
                            className='text-14 cursor-pointer red'
                            onClick={() => navigate(`/test_cases/update/${record.test_case_ref}`)}
                        >
                            #{record.test_case_ref}
                        </span>
                    ) : <></>}
                />
                <TextField key='title' label="Название" />
                <TextField key='status' label="Статус" />
                <RecordField
                    label='Просмотр'
                    render={(record)=>{
                        return <div 
                            className='text-14 cursor-pointer red' 
                            onClick={()=>openTestCaseExecutionDeatail(record?.id)}
                        >
                            Просмотр
                        </div>
                    }}
                />
                <RecordField
                    label='Запуск тест-кейса'
                    render={(record)=>{
                        return <div 
                            className='text-14 cursor-pointer red' 
                            onClick={()=>openTestCaseExecutionForm(record?.id)}
                        >
                            Запустить
                        </div>
                    }}
                />
            </DataGrid>
        </FlexColumn>
    )
}

export default TestRunDetailGrid;